import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallbackCompact } from './ErrorFallbackCompact';
import { ErrorFallback } from './ErrorFallback';
/**
 * Premade error boundary component with a reasonable UI that allows
 * the user to try and reload the component or page.
 * - Wrap around your app to get gracefull crash handling for the whole app
 * - Wrap around a component and pass `compact` to get graceful handling for that component
 *
 * This component will wait 2 seconds, and then try to recover the failed component.
 *
 * @constant
 */
export const AppErrorBoundary = ({ children, compact = false, supportEmailUrl, }) => {
    const [didReload, setDidReload] = useState(false);
    return (_jsx(ErrorBoundary, Object.assign({ fallbackRender: ({ error, resetErrorBoundary }) => {
            !didReload &&
                setTimeout(() => {
                    if (!didReload) {
                        setDidReload(true);
                        resetErrorBoundary();
                    }
                }, 3000);
            if (compact) {
                return (_jsx(ErrorFallbackCompact, Object.assign({}, {
                    error,
                    resetErrorBoundary,
                    supportEmailUrl,
                })));
            }
            return (_jsx(ErrorFallback, Object.assign({}, {
                error,
                resetErrorBoundary,
                supportEmailUrl,
            })));
        } }, { children: children })));
};
